module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "SP"
  }), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-non-verse-fmepi"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_ix",
      "title": "ix"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("I have just escaped a most unpleasant death")]), _c('span', {
    staticClass: "ePub-I"
  }), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("…")])])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-Source-fmeps"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("—CAPTAIN WILLIAM LANCASTER’S SAHARA DIARY")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-non-verse-fmepi-first"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Life at its best is short anyway")]), _c('span', {
    staticClass: "ePub-I"
  }), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("…")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-Source-fmeps"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("—JESSIE KEITH-MILLER")]), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_x",
      "title": "x"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0825b0b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 72
// module chunks = 0